import { apiClient } from "@/lib/api-client";
import type {
  M365ConnectResponseDto,
  M365StatusDto,
} from "../dtos/M365ConnectDto";

export async function initiateConnect(
  organizationId: string | null,
  spaReturnUrl?: string,
): Promise<M365ConnectResponseDto> {
  const response = await apiClient.post<M365ConnectResponseDto>(
    `/organizations/${organizationId}/microsoft365/connect`,
    null,
    { params: { SpaReturnUrl: spaReturnUrl } },
  );
  return response.data;
}

export async function getStatus(
  organizationId: string | null,
): Promise<M365StatusDto> {
  const response = await apiClient.get<M365StatusDto>(
    `/organizations/${organizationId}/microsoft365/status`,
  );
  return response.data;
}

export async function disconnect(organizationId: string | null): Promise<void> {
  await apiClient.delete(
    `/organizations/${organizationId}/microsoft365/disconnect`,
  );
}

export const m365ConnectorService = {
  initiateConnect,
  getStatus,
  disconnect,
};
